<app-dialog-heading [heading]="'Activity Results'"></app-dialog-heading>

<div *ngIf="isBusyCounter > 0">
  <mat-spinner></mat-spinner>
</div>

<div *ngIf="isBusyCounter === 0" class="flex justify-center">
  <div *ngIf="!isHtmlValid" class="flex center">
    <mat-icon class="m-r-5 warning">warning</mat-icon>
    No Results Found.
  </div>
  <div [innerHTML]="html"></div>
</div>
